document.querySelectorAll( '.offset-grid__cell' ).forEach( ( cell ) => {
	const toggle = cell.querySelector( '.offset-grid__cell-layout[aria-expanded]' );

	if ( ! toggle ) {
		return;
	}

	cell.addEventListener( 'click', ( event ) => {
		if ( event.target.closest( '.offset-grid__content' ) ) {
			return;
		}

		const expanded = 'true' === toggle.getAttribute( 'aria-expanded' );

		toggle.setAttribute( 'aria-expanded', expanded ? 'false' : 'true' );
	} );
} );
